export const globalStyles = {
  colors: {
    brand: {
      primary: {
        DEFAULT: "#A41F35",
        50: "#F1B3BD",
        100: "#EDA2AE",
        200: "#E77F90",
        300: "#E05D73",
        400: "#DA3B55",
        500: "#C62540",
        600: "#A41F35",
        700: "#751626",
        800: "#460D17",
        900: "#160407",
      },
      secondary: {
        DEFAULT: "#EF7622",
        50: "#FBE0CD",
        100: "#FAD4BA",
        200: "#F7BD94",
        300: "#F5A56E",
        400: "#F28E48",
        500: "#EF7622",
        600: "#CA5C0F",
        700: "#96440B",
        800: "#622C07",
        900: "#2D1503",
      },
    },
    gray: {
      DEFAULT: "#E8E8E8",
      50: "#FFFFFF",
      100: "#F4F4F4",
      200: "#E8E8E8",
      300: "#CCCCCC",
      400: "#B0B0B0",
      500: "#949494",
      600: "#787878",
      700: "#5C5C5C",
      800: "#404040",
      900: "#242424",
    },
  },
  styles: {
    global: (props) => ({
      body: {
        margin: 0,
        fontFamily:
          '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"',
        fontSize: "0.875rem",
        fontWeight: 400,
        lineHeight: 1.5,
        textAlign: "left",
        color: "#333",
        overflowX: "hidden",
        bg: props.colorMode === "light" ? "#e8e8e8" : "#1F1F1F",
        letterSpacing: "-0.5px",
      },
      html: {
        fontFamily: "DM Sans",
      },
    }),
  },
};
